import styled, { css } from 'styled-components';

export const Icon = styled.div`
    svg {
        width: 16px;
        height: 16px;

        path {
            fill: transparent;
            stroke: rgba(255, 255, 255, 0.5);
            stroke-width: 2px;

            transition:
                stroke 200ms ease,
                fill 200ms ease;
        }
    }
`;

export const Wrapper = styled.button<{ $isLoading?: boolean; $isAdded?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;

    background: rgba(255, 255, 255, 0.05);
    border-radius: 6px;
    border: none;

    height: 30px;
    min-width: 30px;
    padding: 0 7px 0 7px;
    cursor: pointer;

    transition: background-color 200ms ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.15);

        ${Icon} {
            svg {
                path {
                    fill: #ffffff;
                    stroke: #fff;
                }
            }
        }
    }

    ${({ $isLoading }) =>
        $isLoading &&
        css`
            pointer-events: none;
            opacity: 0.5;
            cursor: default;
        `}

    ${({ $isAdded }) =>
        $isAdded &&
        css`
            background-color: #523df1;

            &:hover {
                background-color: #523df1;
            }

            ${Icon} {
                svg {
                    path {
                        fill: #ffffff;
                        stroke-width: 0;
                    }
                }
            }
        `}
`;

export const Count = styled.div`
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #ffffff;
`;
